export enum RothConversionActionTypes {
  SELECT_CONVERSION_FUND = 'SELECT_CONVERSION_FUND',
  DESELECT_CONVERSION_FUND = 'DESELECT_CONVERSION_FUND',
  BATCH_SELECT_CONVERSION_FUND = 'BATCH_SELECT_CONVERSION_FUND',
  UPDATE_CONVERSION_FUND = 'UPDATE_CONVERSION_FUND',
  UPDATE_FUND_ALLOCATION_TYPE = 'UPDATE_FUND_ALLOCATION_TYPE',
  UPDATE_TAX_OPTION = 'UPDATE_TAX_OPTION',
  UPDATE_TAX_PERCENTAGE = 'UPDATE_TAX_PERCENTAGE',
  UPDATE_FUND_ALLOCATE_TOTAL = 'UPDATE_FUND_ALLOCATE_TOTAL',
  ADJUST_FOR_ROTH_ALLOCATION = 'ADJUST_FOR_ROTH_ALLOCATION',
  ADD_NEW_ROTH_FUND = 'ADD_NEW_ROTH_FUND',
  ADD_NEW_ROTH_FUND_FULFILLED = 'ADD_NEW_ROTH_FUND_FULFILLED',
  ADD_NEW_ROTH_FUND_ERROR = 'ADD_NEW_ROTH_FUND_ERROR',
  EMPTY_NEW_FUND = 'EMPTY_NEW_FUND',
  EMPTY_NEW_FUND_ERROR = 'EMPTY_NEW_FUND_ERROR',
  ROTH_CONVERSION_SKIP_STEP_2 = 'ROTH_CONVERSION_SKIP_STEP_2',
  UPDATE_TERMS_AND_CONDITIONS = 'UPDATE_TERMS_AND_CONDITIONS',

  UPDATE_ROTH_BENEFICIARY_OPTION = 'UPDATE_ROTH_BENEFICIARY_OPTION',
  ADD_ROTH_BENEFICIARY = 'ADD_ROTH_BENEFICIARY',
  UPDATE_ROTH_BENEFICIARY = 'UPDATE_ROTH_BENEFICIARY',
  DELETE_ROTH_BENEFICIARY = 'DELETE_ROTH_BENEFICIARY',

  RESET_TRANSACTION = 'RESET_TRANSACTION',
}
